(function () {

  // REMOVE BUTTON COMPONENT
  class RemoveItemButton extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        const container = this.closest('cart-items') || this.closest('cart-drawer-items');
        if (!container) return;

        const index = this.dataset.index;
        container.changeItemQty(index, 0);
      });
    }
  }

  customElements.define('remove-item-btn', RemoveItemButton);

  // MAIN CART COMPONENT
  class CartManager extends HTMLElement {
    constructor() {
      super();

      this.statusNode =
        document.getElementById('shopping-cart-line-item-status') ||
        document.getElementById('CartDrawer-LineItemStatus');

      this.totalItems = this.calculateItems();

      this.handleChange = this.debounce((e) => this.processChange(e), 300);

      this.addEventListener('change', this.handleChange.bind(this));
    }

    calculateItems() {
      return [...this.querySelectorAll('[name="updates[]"]')]
        .map(input => parseInt(input.value) || 0)
        .reduce((sum, val) => sum + val, 0);
    }

    debounce(fn, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }

    processChange(event) {
      const input = event.target;
      const index = input.dataset.index;
      const qty = input.value;
      const name = document.activeElement?.getAttribute('name');

      this.changeItemQty(index, qty, name);
    }

  getSections() {
    const sections = [];

    const mainItems = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    const drawerSubtotal = document.getElementById('cart-drawer-subtotal');
    const drawerItems = document.getElementById('CartDrawer'); // 👈 ADD THIS

    // CART PAGE
    if (mainItems) {
      sections.push({
        key: 'main-cart-items',
        id: mainItems.dataset.id,
        selector: '.main-cart-contents'
      });
    }

    if (footer) {
      sections.push({
        key: 'main-cart-footer',
        id: footer.dataset.id,
        selector: '.cart_footer'
      });
    }

    // CART DRAWER ITEMS (THIS IS YOUR MISSING PIECE)
    if (drawerItems) {
      sections.push({
        key: 'CartDrawer',
        id: drawerItems.dataset.id,
        selector: '.th-cartDrawer_body' // ⚠️ match your liquid
      });
    }

    // DRAWER SUBTOTAL
    if (drawerSubtotal) {
      sections.push({
        key: 'cart-drawer-subtotal',
        id: drawerSubtotal.dataset.id,
        selector: '.price-subtotal'
      });
    }

    // GLOBAL
    sections.push(
      {
        key: 'cart-icon-bubble',
        id: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        key: 'cart-live-region-text',
        id: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        key: 'cart-icon-bubble-sticky-footer',
        id: 'cart-icon-bubble-sticky-footer',
        selector: '.shopify-section'
      }
    );

    return sections;
  }

    async changeItemQty(line, quantity, focusName = null) {
      this.startLoading(line);

      try {
        const payload = {
          line,
          quantity,
          sections: this.getSections().map(s => s.id),
          sections_url: window.location.pathname
        };

        const res = await fetch(routes.cart_change_url, {
          ...fetchConfig(),
          body: JSON.stringify(payload)
        });

        const data = await res.json();

        this.refreshUI(data);
        this.updateAccessibility(line, data.item_count);
        this.restoreFocus(line, focusName, data.item_count);

      } catch (err) {
        this.handleError();
      }

      this.stopLoading();
    }

    refreshUI(data) {
      const isEmpty = data.item_count === 0;

      this.classList.toggle('is-empty', isEmpty);

      const drawer = document.querySelector('cart-drawer');
      const footer = document.getElementById('main-cart-footer');

      if (drawer) drawer.classList.toggle('is-empty', isEmpty);
      if (footer) footer.classList.toggle('is-empty', isEmpty);

      this.getSections().forEach(section => {
        const container = document.getElementById(section.key);
        if (!container) return;

        const target =
          container.querySelector(section.selector) || container;

        target.innerHTML = this.extractHTML(
          data.sections[section.id],
          section.selector
        );
      });
    }

    updateAccessibility(line, count) {
      if (this.totalItems === count) {
        const errorNode =
          document.getElementById(`Line-item-error-${line}`) ||
          document.getElementById(`CartDrawer-LineItemError-${line}`);

        const qtyInput =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);

        if (errorNode && qtyInput) {
          errorNode.querySelector('.cart-item_error-text').innerHTML =
            window.cartStrings.quantityError.replace('[quantity]', qtyInput.value);
        }
      }

      this.totalItems = count;

      this.statusNode?.setAttribute('aria-hidden', true);

      const liveRegion =
        document.getElementById('cart-live-region-text') ||
        document.getElementById('CartDrawer-LiveRegionText');

      if (liveRegion) {
        liveRegion.setAttribute('aria-hidden', false);
        setTimeout(() => {
          liveRegion.setAttribute('aria-hidden', true);
        }, 1000);
      }
    }

    restoreFocus(line, inputName, count) {
      const drawer = document.querySelector('cart-drawer');

      const item =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(`CartDrawer-Item-${line}`);

      if (item && inputName && item.querySelector(`[name="${inputName}"]`)) {
        const el = item.querySelector(`[name="${inputName}"]`);
        drawer ? trapFocus(drawer, el) : el.focus();
      } else if (count === 0 && drawer) {
        trapFocus(drawer.querySelector('.drawer_inner-empty'), drawer.querySelector('a'));
      } else if (document.querySelector('.cart-item') && drawer) {
        trapFocus(drawer, document.querySelector('.cart-item_name'));
      }
    }

    extractHTML(html, selector) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector(selector)?.innerHTML || '';
    }

    startLoading(line) {
      const container =
        document.getElementById('main-cart-items') ||
        document.getElementById('CartDrawer-CartItems');

      const footer = document.getElementById('main-cart-footer');

      container?.classList.add('cart_items--disabled');

      if (footer) {
        Spinner.show();
      } else {
        SpinnerCart.show();
      } 

      document.activeElement?.blur();

      this.statusNode?.setAttribute('aria-hidden', false);
    }

    stopLoading() {
      const container =
        document.getElementById('main-cart-items') ||
        document.getElementById('CartDrawer-CartItems');

      const footer = document.getElementById('main-cart-footer');

      container?.classList.remove('cart_items--disabled');

      if (footer) {
        Spinner.hide();
      } else {
        SpinnerCart.hide();
      } 
      
    }

    handleError() {
      const errBox =
        document.getElementById('cart-errors') ||
        document.getElementById('CartDrawer-CartErrors');

      if (errBox) errBox.textContent = window.cartStrings.error;
    }
  }

  customElements.define('cart-items', CartManager);


  // CART NOTE COMPONENT
  if (!customElements.get('cart-note')) {
    class NoteHandler extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          this.debounce((e) => this.save(e), 300)
        );
      }

      debounce(fn, delay) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), delay);
        };
      }

      save(event) {
        fetch(routes.cart_update_url, {
          ...fetchConfig(),
          body: JSON.stringify({ note: event.target.value })
        });
      }
    }

    customElements.define('cart-note', NoteHandler);
  }

  /* Cart Quantity */
  document.addEventListener('click', function(e) {

    // PLUS
    if (e.target.closest('.js-qty-plus')) {
      const btn = e.target.closest('.js-qty-plus');
      const index = btn.dataset.index;

      const input =
      document.querySelector(`#Drawer-quantity-${index}`) ||
      document.querySelector(`#Quantity-${index}`);
      if (!input) return;

      input.value = parseInt(input.value || 0) + 1;

      // trigger Shopify cart update
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // MINUS
    if (e.target.closest('.js-qty-minus')) {
      const btn = e.target.closest('.js-qty-minus');
      const index = btn.dataset.index;

      const input =
      document.querySelector(`#Drawer-quantity-${index}`) ||
      document.querySelector(`#Quantity-${index}`);
      if (!input) return;

      let value = parseInt(input.value || 0);
      value = Math.max(0, value - 1);

      input.value = value;

      // trigger Shopify cart update
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

  });
})();
